/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Market
 */
export interface Market {
  /**
   *
   * @type {number}
   * @memberof Market
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Market
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof Market
   */
  flag: string;
  /**
   *
   * @type {string}
   * @memberof Market
   */
  nameAr: string;
  /**
   *
   * @type {string}
   * @memberof Market
   */
  nameEn: string;
}

export function MarketFromJSON(json: any): Market {
  return MarketFromJSONTyped(json, false);
}

export function MarketFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Market {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    code: json['code'],
    flag: json['flag'],
    nameAr: json['name_ar'],
    nameEn: json['name_en'],
  };
}

export function MarketToJSON(value?: Market | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    code: value.code,
    flag: value.flag,
    name_ar: value.nameAr,
    name_en: value.nameEn,
  };
}
